export default {
    common: {
        title: "Editar Imagem",
        cancel: "Cancelar",
        save: "Salvar",
        crop: "Cultura",
        adjustments: "Ajustes",
        filters: "Filtros",
        frames: "Quadros",
        overlays: "Sobreposições",
        text: "Texto",
        stickers: "Adesivos",
        brush: "Escova",
        ai: "Criar imagem usando IA",
        reset: "Reiniciar",
        comingSoon: 'Em breve...',
    },
};
